export default {
    title: 'Incidents',
    'create-button': 'New incident',
    headers: {
        id: 'ID',
        title: 'Title',
        description: 'Description',
        state: 'State',
        severity: 'Severity',
        deadline: 'Deadline',
        createdDateTime: 'Created at',
        closedDateTime: 'Closed at',
        duration: 'Duration',
        assignedUsers: 'Assigned to',
        caseId: 'Case ID',
        workflowId: 'Workflow ID',
    },
    filters: {
        search: 'Search by title',
        assignment: 'Assignment',
        created: 'Created at',
        tags: 'Tags',
        result: 'Result',
    },
    assignments: {
        'list-label': 'List of assigned users',
        'select-new': 'Select user',
    },
    'confirm-unsaved': {
        title: 'Are you sure you want to exit?',
        description: 'You have unsaved changes. Exiting now will discard these changes.',
    },
    archive: {
        title: 'Archived incidents',
    },
    automation: {
        title: 'Automation settings',
    },
    record: {
        'go-to-record': 'Open record',
        'no-record': 'No record attached',
    },
}
